document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initCarousel, 200);
});

function initCarousel() {
  const productGallery = document.querySelector('.product__media-list, .product-media-container');
  const allMedia = document.querySelectorAll('.product__media-item');
  const thumbnailButtons = document.querySelectorAll('.thumbnail-list__item button');
  
  if (!productGallery || allMedia.length <= 1) return;

  let currentIndex = 0;

  // Створюємо контейнер для стрілок, який буде поверх всієї галереї
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'product-carousel-arrows-wrapper';
  arrowContainer.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 20;';
  
  const prevArrow = document.createElement('button');
  prevArrow.className = 'product-carousel-arrow product-carousel-arrow--prev';
  prevArrow.style.pointerEvents = 'auto';
  prevArrow.innerHTML = '<svg viewBox="0 0 8 14"><path d="M7 1L1 7l6 6" stroke="white" stroke-width="2" fill="none"/></svg>';
  prevArrow.setAttribute('aria-label', 'Попереднє зображення');
  prevArrow.type = 'button';

  const nextArrow = document.createElement('button');
  nextArrow.className = 'product-carousel-arrow product-carousel-arrow--next';
  nextArrow.style.pointerEvents = 'auto';
  nextArrow.innerHTML = '<svg viewBox="0 0 8 14"><path d="M1 1l6 6-6 6" stroke="white" stroke-width="2" fill="none"/></svg>';
  nextArrow.setAttribute('aria-label', 'Наступне зображення');
  nextArrow.type = 'button';

  arrowContainer.appendChild(prevArrow);
  arrowContainer.appendChild(nextArrow);
  
  // Додаємо стрілки до батьківського контейнера галереї
  const galleryWrapper = productGallery.parentElement || productGallery;
  galleryWrapper.style.position = 'relative';
  galleryWrapper.appendChild(arrowContainer);

  function navigate(direction) {
    currentIndex += direction;
    
    if (currentIndex < 0) {
      currentIndex = allMedia.length - 1;
    } else if (currentIndex >= allMedia.length) {
      currentIndex = 0;
    }

    if (thumbnailButtons[currentIndex]) {
      thumbnailButtons[currentIndex].click();
    }
  }

  prevArrow.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    navigate(-1);
    return false;
  }, true);

  nextArrow.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    navigate(1);
    return false;
  }, true);

  // Відстежуємо поточний індекс
  thumbnailButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      currentIndex = index;
    });
  });
}

